module.exports = __webpack_public_path__ + "../resources/images/illustration_junk-e54be9ea53e39ba70c51037a83cc0ec4.svg";